import React from 'react'
// import {Link} from 'react-scroll'
import { NavLink as RouterLink } from "react-router-dom";
import { Link } from "react-router-dom";
function Welcome2() {
    return (
        <section>
            <div className="block color-scheme-1">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-10 col-lg-8">
                            <div className="section-sub-title center">
                                <article className="section-title-body white">
                                <h1 className="head-title">
                                    <span style={{ fontWeight: '700' }}>
                                        OUR PURPOSE
                                    </span>
                                </h1>

                                        <p className="head-text">
                                            Americans4Hindus (A4H) is a unified national ecosystem dedicated to empowering the Hindu-American community through culture, education, community service, civic engagement, leadership, advocacy, and political participation. Under one umbrella, A4H brings together Americans4Hindus PAC, Americans4Hindus Political Action Committee (A4H PAC), Americans4Hindus Non-Profit Organization (501(c)(3)), Americans4Hindus Dharma Action Council (A4H DAC) (501(c)(4)), and Festival of Globe Non-Profit Organization (FOG) (501(c)(3)) to preserve Hindu heritage, promote charitable and educational initiatives, strengthen civic responsibility, and expand community leadership across the United States.
                                            </p>
                                        <p className="head-text">
                                            Together, these organizations create opportunities for individuals, families, youth, professionals, and community leaders to learn, serve, lead, and make a lasting impact. By integrating cultural celebrations, community outreach, health and wellness, youth mentorship, public policy education, grassroots advocacy, and civic participation, A4H is building a stronger, more engaged, and influential Hindu-American community for generations to come.
                                        </p>
                                        <div
                                            className="fog-action-buttons"
                                            style={{ marginTop: "22px", position: "relative", zIndex: 3, pointerEvents: "auto" }}
                                        >
    <Link
  to="/donations"
  className="fog-btn"
  style={{
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "auto",
  }}
>
  Donate
</Link>
</div>
                                        {/* <Link to='portfolio' className="btn-default white btn-move" smooth={false} duration={800}>Donate</Link>&nbsp;
                                        <Link to='contact' className="btn-default active btn-move t1" smooth={false} duration={800}>Become a member</Link> */}
                                </article>
                            </div>   
                        </div>
                    </div>
                </div>

            </div>
        </section>
    )
}

export default Welcome2
